"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seperateCreditCard = exports.getLastInputedChar = exports.getCurrentValue = void 0;
var _constants = require("./constants");
var getLastInputedChar = function getLastInputedChar(value) {
  if (!value || value === '') {
    return null;
  }
  var inputVal = value.split('');
  var lastChar = inputVal[inputVal.length - 1];
  return lastChar;
};
exports.getLastInputedChar = getLastInputedChar;
var getCurrentValue = function getCurrentValue(val) {
  if (!val || val === '') {
    return val;
  }
  return val.replace(/[\s-]+/g, '');
};
exports.getCurrentValue = getCurrentValue;
var trimCharacter = function trimCharacter(str, char) {
  var newStr = str.trim();

  // Trim start of string
  while (char.indexOf(newStr[0]) !== -1) {
    newStr = newStr.slice(1);
  }

  // Trim end of string
  while (char.indexOf(newStr[newStr.length - 1]) !== -1) {
    newStr = newStr.slice(0, -1);
  }
  return newStr;
};
var separateCardNumber = function separateCardNumber(cardNumber, cardType) {
  if (cardType) {
    var offsets = [].concat(0, cardType.gaps, cardNumber.length);
    var components = [];
    for (var i = 0; offsets[i] < cardNumber.length; i++) {
      var start = offsets[i];
      var end = Math.min(offsets[i + 1], cardNumber.length);
      components.push(cardNumber.substring(start, end));
    }
    return components.join(_constants.DEFAULT_GAP_CHARACTER);
  }
  return cardNumber;
};
var seperateCreditCard = function seperateCreditCard(creditCardNumber, cardTypeInfo) {
  var newCreditCardNumber = creditCardNumber;
  if (cardTypeInfo) {
    newCreditCardNumber = separateCardNumber(newCreditCardNumber, cardTypeInfo);
    newCreditCardNumber = trimCharacter(newCreditCardNumber, _constants.DEFAULT_GAP_CHARACTER);
  }
  return newCreditCardNumber;
};
exports.seperateCreditCard = seperateCreditCard;